<template>
  <div class="input-radio-select" :class="{ 'input-radio-select--vertical' : isVertical }">
    <div v-if="icon" class="input-radio-select__icon">
      <fa :icon="icon" fixed-width />
    </div>
    <div v-if="label" class="input-radio-select__label">
      {{ label }}
    </div>
    <div class="input-radio-select__buttons">
      <div 
        class="input-radio-select__button touch"
        :class="{ 'input-radio-select__button--active': selection.value === value }"
        v-for="selection in selections"
        :key="selection.value"
        @click="$emit('input', selection.value)"
      >
        {{ selection.label[language.code] }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: [ 'icon', 'label', 'selections', 'value', 'isVertical'],

  computed: {
    ...mapGetters([
      'language'
    ]),
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
.input-radio-select {
  &__icon {
    font-size: 2rem;

    svg {
      margin-right: 1rem;
    }
  }

  &__label {
    display: block;
    font-size: 1.5rem;
    margin-bottom: 0.5em;
    text-transform: capitalize;
  }

  &__buttons {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }

  &__button {
    border: 0.2rem solid $white;
    border-radius: 0.7rem;
    font-size: 1.5rem;
    padding: 0.3em 0.5em;
    min-width: 3rem;
    opacity: 0.6;
    text-align: center;
    text-transform: capitalize;
    transition: background-color 0.15s ease-in;

    &--active {
      background: $white;
      color: $black;
      opacity: 1;
    }
  }

  &--vertical {
    .input-radio-select__buttons {
      align-items: flex-start;
      flex-direction: column;

      .input-radio-select__button {
        margin-bottom: .5rem;
        text-align: left;
        width: 100%;
      }
    }
  }
}
</style>

